<template>
    <div class="process">
        <div class="box" v-if="state!==''">
            <img src="../../../static/image/submit@2x.png" alt="">
            <p>申请售后</p>
        </div>
        <div class="box" v-if="state===''">
            <img src="../../../static/image/submit_orange@2x.png" alt="">
            <p>申请售后</p>
        </div>
        <div class="spot" v-if="state===1">
            <p class="fs12 font-color-FF7 mar-bot-10">审核中</p>
            <img src="../../../static/image/xzdiandian@2x.png" alt="">
        </div>
        <div class="spot" v-if="state!==1 && state!==''">
            <img src="../../../static/image/line@2x.png" alt="">
        </div>
        <div class="spot" v-if="state===''">
            <img src="../../../static/image/huidiandian@2x.png" alt="">
        </div>
        <div class="box" v-if="state===1 || state===''">
            <img src="../../../static/image/order_grey@2x.png" alt="">
            <p>订单处理</p>
        </div>
        <div class="box" v-if="state===2 || state===3 || state===4 || state===5 || state===8 || state===9 || state==10">
            <img src="../../../static/image/order@2x.png" alt="">
            <p>审核通过</p>
        </div>
        <div class="box" v-if="state===6 || state===7">
            <img src="../../../static/image/order@2x.png" alt="">
            <p>审核不通过</p>
        </div>
        <div class="spot" v-if="state===10 || state===7">
            <p v-if="state===10" class="fs12 font-color-FF7 mar-bot-10">录入物流</p>
            <p v-if="state===7" class="fs12 font-color-FF7 mar-bot-10">评审中</p>
            <img src="../../../static/image/xzdiandian@2x.png" alt="">
        </div>
        <div class="spot" v-if="state===1 || state===6 || state===''">
            <img src="../../../static/image/huidiandian@2x.png" alt="">
        </div>
        <div class="spot" v-if="state===2 || state===3 || state===4 || state===5 || state===8 || state===9">
            <img src="../../../static/image/line@2x.png" alt="">
        </div>
        <div class="box" v-if="state===3">
            <img src="../../../static/image/transport_orange@2x.png" alt="">
            <p>退货中</p>
        </div>
        <div class="box" v-if="state===1 || state===6 || state===10 || state===7 || state===''">
            <img src="../../../static/image/transport_grey@2x.png" alt="">
            <p>退货中</p>
        </div>
        <div class="box" v-if="state===2 || state===4 || state===5 || state===8 || state ===9">
            <img src="../../../static/image/transport@2x.png" alt="">
            <p>退货中</p>
        </div>
        <div class="spot" v-if="state===2">
            <p class="fs12 font-color-FF7 mar-bot-10">退款中</p>
            <img src="../../../static/image/xzdiandian@2x.png" alt="">
        </div>
        <div class="spot" v-if="state===4 || state===5 || state===8 || state===9">
            <img src="../../../static/image/line@2x.png" alt="">
        </div>
        <div class="spot" v-if="state===1 || state===3 || state===6 || state===7 || state===10 || state===''">
            <img src="../../../static/image/huidiandian@2x.png" alt="">
        </div>
        <div class="box" v-if="state===4">
            <img src="../../../static/image/complete@2x.png" alt="">
            <p>退款成功</p>
        </div>
        <div class="box" v-if="state===5">
            <img src="../../../static/image/complete@2x.png" alt="">
            <p>退款失败</p>
        </div>
        <div class="box" v-if="state===8">
            <img src="../../../static/image/complete@2x.png" alt="">
            <p>退货完成，拒绝退款</p>
        </div>
        <div class="box" v-if="state===9">
            <img src="../../../static/image/complete@2x.png" alt="">
            <p>已关闭</p>
        </div>
        <div class="box" v-if="state===1 || state===2 || state===3 || state===6 || state===7 || state===10 || state===''">
            <img src="../../../static/image/complete_grey@2x.png" alt="">
            <p>完成</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['state'],
    data () {
        return {
        }
    }
}
</script>
<style lang="scss" scoped>
.process{
    width: 100%;
    display: flex;
    text-align: center;
    margin-top: 100px;
    .box{
        flex: 1;
        img{
            width: 35px;
            height: 35px;
            margin-bottom: 20px;
        }
        p{
            font-size: 14px;
        }
    }
    .spot{
        width: 130px;
        position: relative;
        margin-top: 5px;
        img{
            width: 130px;
        }
        p{
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/afterSaleState.vue